import Route from '@ember/routing/route';

export default class SiteBillingAccountHistoryRoute extends Route {
  setupController(controller) {
    super.setupController(...arguments);
    controller.performQuery();
  }
}
